import React from 'react';
import { ExtraContainer, Text } from './Loading.styled';

const Loading = () => {
  return (
    <ExtraContainer>
      <Text>Loading.....</Text>
    </ExtraContainer>
  );
};

export default Loading;
